import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => {
  return {
    resultsText: {
      fontSize: "14px",
      fontWeight: 700,
      margin: "24px 0",
    },
  };
});
